import { User } from 'fitify-types/src/types/user'
import { ReviewCard } from 'fitify-ui-onboarding/src/components/GenderFunnel/ReviewCard/ReviewCard'
import { SegmentWrapper } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment.Styled'
import { Typography } from 'fitify-ui-onboarding/src/components/Typography'
import { useTranslation } from 'next-i18next/pages'
import { useMemo } from 'react'
import { styled, useTheme } from 'styled-components'

import { useFunnel } from '../../hooks/useFunnel'
import { useDataState } from '../../utils/state'

const StyledSegment = styled(SegmentWrapper)`
  gap: 0.75rem;
`

export const Reviews = () => {
  const { t } = useTranslation()
  const funnel = useFunnel()
  const { data } = useDataState()
  const theme = useTheme()

  const gender = data[funnel || 'shared'].gender

  const reviewIdentifier = useMemo(() => {
    if (gender === User.Profile.Gender.Male) {
      return ['m_1', 'm_2', 'm_3']
    }

    if (gender === User.Profile.Gender.Female) {
      return ['f_1', 'f_2', 'f_3']
    }

    return ['f_1', 'm_2', 'f_3']
  }, [gender])

  return (
    <StyledSegment title={t('paywall_success_stories')}>
      {reviewIdentifier.map((genderId) => (
        <ReviewCard
          key={genderId}
          title={t(`paywall_user_review_${genderId}_title`)}
          subtitle={t(`paywall_user_review_${genderId}_name`)}
          reviewText={t(`paywall_user_review_${genderId}_body`)}
          rating={5}
          width="100%"
          maxWidth="100%"
        />
      ))}
      <Typography
        $variant="Poppins/T3"
        $color={theme.colors['N Content/Secondary']}
        $textAlign="center"
      >
        {t('common_user_reviews_disclaimer')}
      </Typography>
    </StyledSegment>
  )
}
